<template>
  <div class="control_app">

    <div class="control__item control__text">
      <div class="control__title">
        Grayscale
      </div>
      <div class="control__action">
        <div class="font_choice">
          <div class="fakeoverlay" @click="enabledField('grayscaleStatus', grayscaleStatus), changeColor()" :class='{disabledStatus: !grayscaleStatus}'></div>
          <el-select class="font_choice" :disabled="!grayscaleStatus" v-model="grayscale" @change="changeColor" placeholder="original">
            <el-option
              :key="index"
              v-for="(item, index) in grayscales"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <el-checkbox class="enable_checkbox" v-model="grayscaleStatus" @change="changeColor" ></el-checkbox>
      </div>
    </div>

    <div class="control__item control__text">
      <div class="control__title">
        Brightness
      </div>
      <div class="control__action">
        <div class="slider_wrapper">
          <div class="fakeoverlay" @click="enabledField('brightnessStatus', brightnessStatus)" :class='{disabledStatus: !brightnessStatus}'></div>
          <el-slider :min="-100" class="slider" :max="100" v-model="brightness" :disabled="!brightnessStatus" @change="changeColor"
          ></el-slider>
        </div>
        <el-checkbox class="enable_checkbox" v-model="brightnessStatus" @change="changeColor" ></el-checkbox>
      </div>
    </div>

    <div class="control__item control__text">
      <div class="control__title">
        Contrast
      </div>
      <div class="control__action">
        <div class="slider_wrapper">
          <div class="fakeoverlay" @click="enabledField('contrastStatus', contrastStatus)" :class='{disabledStatus: !contrastStatus}'></div>
          <el-slider :min="-100" class="slider" :max="100" v-model="contrast" :disabled="!contrastStatus" @change="changeColor"
          ></el-slider>
        </div>
        <el-checkbox class="enable_checkbox" v-model="contrastStatus" @change="changeColor" ></el-checkbox>
      </div>
    </div>

    <div class="control__item control__text">
      <div class="control__title">
        Exposure
      </div>
      <div class="control__action">
        <div class="slider_wrapper">
          <div class="fakeoverlay" @click="enabledField('exposureStatus', exposureStatus)" :class='{disabledStatus: !exposureStatus}'></div>
          <el-slider :min="-100" class="slider" :max="100" v-model="exposure" :disabled="!exposureStatus" @change="changeColor"
          ></el-slider>
        </div>
        <el-checkbox class="enable_checkbox" v-model="exposureStatus" @change="changeColor" ></el-checkbox>
      </div>
    </div>

    <div class="control__item control__text">
      <div class="control__title">
        Hue
      </div>
      <div class="control__action">
        <div class="slider_wrapper">
          <div class="fakeoverlay" @click="enabledField('hueStatus', hueStatus)" :class='{disabledStatus: !hueStatus}'></div>
          <el-slider :min="-100" class="slider" :max="100" v-model="hue" :disabled="!hueStatus" @change="changeColor"
          ></el-slider>
        </div>
        <el-checkbox class="enable_checkbox" v-model="hueStatus" @change="changeColor" ></el-checkbox>
      </div>
    </div>

    <div class="control__item control__text">
      <div class="control__title">
        Saturation
      </div>
      <div class="control__action">
        <div class="slider_wrapper">
          <div class="fakeoverlay" @click="enabledField('saturationStatus', saturationStatus)" :class='{disabledStatus: !saturationStatus}'></div>
          <el-slider :min="-100" class="slider" :max="100" v-model="saturation" :disabled="!saturationStatus" @change="changeColor"
          ></el-slider>
        </div>
        <el-checkbox class="enable_checkbox" v-model="saturationStatus" @change="changeColor" ></el-checkbox>
      </div>
    </div>

    <div class="control__item control__text">
      <div class="control__title">
        Lightness
      </div>
      <div class="control__action">
        <div class="slider_wrapper">
          <div class="fakeoverlay" @click="enabledField('lightnessStatus', lightnessStatus)" :class='{disabledStatus: !lightnessStatus}'></div>
          <el-slider :min="-100" class="slider" :max="100" v-model="lightness" :disabled="!lightnessStatus" @change="changeColor"
          ></el-slider>
        </div>
        <el-checkbox class="enable_checkbox" v-model="lightnessStatus" @change="changeColor" ></el-checkbox>
      </div>
    </div>

    <div class="control__item control__text">
      <div class="control__title">
        Shadows
      </div>
      <div class="control__action">
        <div class="slider_wrapper">
          <div class="fakeoverlay" @click="enabledField('shadowsStatus', shadowsStatus)" :class='{disabledStatus: !shadowsStatus}'></div>
          <el-slider :min="-100" class="slider" :max="100" v-model="shadows" :disabled="!shadowsStatus" @change="changeColor"
          ></el-slider>
        </div>
        <el-checkbox class="enable_checkbox" v-model="shadowsStatus" @change="changeColor" ></el-checkbox>
      </div>
    </div>

    <div class="control__item control__text">
      <div class="control__title">
        Highlights
      </div>
      <div class="control__action">
        <div class="slider_wrapper">
          <div class="fakeoverlay" @click="enabledField('highlightsStatus', highlightsStatus)" :class='{disabledStatus: !highlightsStatus}'></div>
          <el-slider :min="-100" class="slider" :max="100" v-model="highlights" :disabled="!highlightsStatus" @change="changeColor"
          ></el-slider>
        </div>
        <el-checkbox class="enable_checkbox" v-model="highlightsStatus" @change="changeColor" ></el-checkbox>
      </div>
    </div>

    <div class="control__item control__btn">
      <div class="showurl" @click="doCopy">
        <span>{{ baseUrl }}<span v-if="
          grayscaleStatus ||
          brightnessStatus && brightness !== 0 ||
          contrastStatus && contrast !== 0 ||
          exposureStatus && exposure !== 0 ||
          hueStatus && hue !== 0 ||
          saturationStatus && saturation !== 0 ||
          lightnessStatus && lightness !== 0 ||
          shadowsStatus && shadows !== 0 ||
          highlightsStatus && highlights !== 0">?</span></span>
        <span ref="grayscalespan" class="urlspan" v-show="grayscaleStatus">grayscale={{ grayscale }}</span>
        <span ref="brightnessspan" class="urlspan" v-show="brightnessStatus && brightness !== 0">brightness={{ brightness }}</span>
        <span ref="contrastspan" class="urlspan" v-show="contrastStatus && contrast !== 0">contrast={{ contrast }}</span>
        <span ref="exposurespan" class="urlspan" v-show="exposureStatus && exposure !== 0">exposure={{ exposure }}</span>
        <span ref="huespan" class="urlspan" v-show="hueStatus && hue !== 0">hue={{ hue }}</span>
        <span ref="saturationspan" class="urlspan" v-show="saturationStatus && saturation !== 0">saturation={{ saturation }}</span>
        <span ref="lightnessspan" class="urlspan" v-show="lightnessStatus && lightness !== 0">lightness={{ lightness }}</span>
        <span ref="shadowsspan" class="urlspan" v-show="shadowsStatus && shadows !== 0">shadows={{ shadows }}</span>
        <span ref="highlightsspan" class="urlspan" v-show="highlightsStatus && highlights !== 0">highlights={{ highlights }}</span>
      </div>
    </div>
    <div class="actions">
      <div class="actions-passive">
        <div class="reset" @click="doReset">
          <i class="fa fa-redo"></i>
        </div>
      </div>
      <div class="actions-active">
        <el-button
          @click.prevent="doCopy"
          class="copybutton"
          icon="fa fa-copy"
        >
        </el-button>
        <div class="copymessage" ref="copymessage">{{copymsg}}</div>
        <div class="external" @click="moveToLink">
          <i class="fa fa-external-link-alt"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      grayscale: 'true',
      grayscaleStatus: false,
      grayscales: [{ label: 'True', value: 'true' }, { label: 'False', value: 'false' }],
      brightness: 0,
      brightnessStatus: true,
      contrast: 0,
      contrastStatus: true,
      exposure: 0,
      exposureStatus: true,
      hue: 0,
      hueStatus: true,
      saturation: 0,
      saturationStatus: true,
      lightness: 0,
      lightnessStatus: true,
      shadows: 0,
      shadowsStatus: true,
      highlights: 0,
      highlightsStatus: true,
      copymsg: '',
      baseUrl: 'https://demo.sirv.com/hang.jpg'
    }
  },
  computed: {
    ...mapState([
      'defaultUrl',
      'reset'
    ]),
    showurl () {
      let connecter = '&'
      let grayscale = this.grayscaleStatus !== false ? `${connecter}grayscale=${this.grayscale}` : ``
      let brightness = this.brightness !== 0 && this.brightnessStatus !== false ? `${connecter}brightness=${this.brightness}` : ``
      let contrast = this.contrast !== 0 && this.contrastStatus !== false ? `${connecter}contrast=${this.contrast}` : ``
      let exposure = this.exposure !== 0 && this.exposureStatus !== false ? `${connecter}exposure=${this.exposure}` : ``
      let hue = this.hue !== 0 && this.hueStatus !== false ? `${connecter}hue=${this.hue}` : ``
      let saturation = this.saturation !== 0 && this.saturationStatus !== false ? `${connecter}saturation=${this.saturation}` : ``
      let lightness = this.lightness !== 0 && this.lightnessStatus !== false ? `${connecter}lightness=${this.lightness}` : ``
      let shadows = this.shadows !== 0 && this.shadowsStatus !== false ? `${connecter}shadows=${this.shadows}` : ``
      let highlights = this.highlights !== 0 && this.highlightsStatus !== false ? `${connecter}highlights=${this.highlights}` : ``

      let url = `${grayscale}${brightness}${contrast}${exposure}${hue}${saturation}${lightness}${shadows}${highlights}`

      let arr = url.split('')
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] === '&') { arr[i] = '?'; break }
      }
      url = arr.join('')
      return url
    }
  },
  mounted () {
    this.deleteAmp()
  },
  methods: {
    deleteAmp () {
      let statuses = [
        { status: this.grayscaleStatus, span: this.$refs.grayscalespan },
        { status: this.brightnessStatus, span: this.$refs.brightnessspan },
        { status: this.contrastStatus, span: this.$refs.contrastspan },
        { status: this.exposureStatus, span: this.$refs.exposurespan },
        { status: this.hueStatus, span: this.$refs.huespan },
        { status: this.saturationStatus, span: this.$refs.saturationspan },
        { status: this.lightnessStatus, span: this.$refs.lightnessspan },
        { status: this.shadowsStatus, span: this.$refs.shadowsspan },
        { status: this.highlightsStatus, span: this.$refs.highlightsspan }
      ]
      statuses.forEach(item => {
        item.span.classList.remove('withoutAmp')
      })
      let spans = []
      statuses.map(item => {
        if (item.status === true) {
          spans.push(item)
        }
      })
      if (spans.length !== 0) {
        spans[0].span.classList.add('withoutAmp')
      }
    },
    moveToLink () {
      window.open(this.defaultUrl)
    },
    convertShowUrl (w) {
      return this.showurl.replace('?', `?w=${w}&`)
    },
    changeColor () {
      this.$store.dispatch('changeColor', {
        defaultUrl: `${this.baseUrl}${this.showurl}`,
        url: `${this.baseUrl}${this.convertShowUrl(500)}`,
        url2: `${this.baseUrl}${this.convertShowUrl(1000)}`,
      })
    },
    doReset () {
      this.$store.dispatch('reset')
    },
    doCopy () {
      this.$copyText(`${this.baseUrl}${this.showurl}`).then((e) => {
        this.copymsg = 'Copied'
        setTimeout(() => {
          this.copymsg = ''
        }, 3000)
      }, function (e) {
        alert('Can not copy')
        console.log(e)
      })
    },
    enabledField (variable, params) {
      if (params === false) {
        this[variable] = !params
      }
    }
  },
  watch: {
    grayscale () {
      this.$refs.grayscalespan.classList.add('highlights')
      setTimeout(() => {
        this.$refs.grayscalespan.classList.remove('highlights')
      }, 1000)
    },
    grayscaleStatus (val) {
      this.deleteAmp()
      if (val === true) {
        this.$refs.grayscalespan.classList.add('highlights')
        setTimeout(() => {
          this.$refs.grayscalespan.classList.remove('highlights')
        }, 1000)
      }
    },
    brightness () {
      this.$refs.brightnessspan.classList.add('highlights')
      setTimeout(() => {
        this.$refs.brightnessspan.classList.remove('highlights')
      }, 1000)
    },
    brightnessStatus (val) {
      this.deleteAmp()
      if (val === true) {
        this.$refs.brightnessspan.classList.add('highlights')
        setTimeout(() => {
          this.$refs.brightnessspan.classList.remove('highlights')
        }, 1000)
      }
    },
    contrast () {
      this.$refs.contrastspan.classList.add('highlights')
      setTimeout(() => {
        this.$refs.contrastspan.classList.remove('highlights')
      }, 1000)
    },
    contrastStatus (val) {
      this.deleteAmp()
      if (val === true) {
        this.$refs.contrastspan.classList.add('highlights')
        setTimeout(() => {
          this.$refs.contrastspan.classList.remove('highlights')
        }, 1000)
      }
    },
    exposure () {
      this.$refs.exposurespan.classList.add('highlights')
      setTimeout(() => {
        this.$refs.exposurespan.classList.remove('highlights')
      }, 1000)
    },
    exposureStatus (val) {
      this.deleteAmp()
      if (val === true) {
        this.$refs.exposurespan.classList.add('highlights')
        setTimeout(() => {
          this.$refs.exposurespan.classList.remove('highlights')
        }, 1000)
      }
    },
    hue () {
      this.$refs.huespan.classList.add('highlights')
      setTimeout(() => {
        this.$refs.huespan.classList.remove('highlights')
      }, 1000)
    },
    hueStatus (val) {
      this.deleteAmp()
      if (val === true) {
        this.$refs.huespan.classList.add('highlights')
        setTimeout(() => {
          this.$refs.huespan.classList.remove('highlights')
        }, 1000)
      }
    },
    saturation () {
      this.$refs.saturationspan.classList.add('highlights')
      setTimeout(() => {
        this.$refs.saturationspan.classList.remove('highlights')
      }, 1000)
    },
    saturationStatus (val) {
      this.deleteAmp()
      if (val === true) {
        this.$refs.saturationspan.classList.add('highlights')
        setTimeout(() => {
          this.$refs.saturationspan.classList.remove('highlights')
        }, 1000)
      }
    },
    lightness () {
      this.$refs.lightnessspan.classList.add('highlights')
      setTimeout(() => {
        this.$refs.lightnessspan.classList.remove('highlights')
      }, 1000)
    },
    lightnessStatus (val) {
      this.deleteAmp()
      if (val === true) {
        this.$refs.lightnessspan.classList.add('highlights')
        setTimeout(() => {
          this.$refs.lightnessspan.classList.remove('highlights')
        }, 1000)
      }
    },
    shadows () {
      this.$refs.shadowsspan.classList.add('highlights')
      setTimeout(() => {
        this.$refs.shadowsspan.classList.remove('highlights')
      }, 1000)
    },
    shadowsStatus (val) {
      this.deleteAmp()
      if (val === true) {
        this.$refs.shadowsspan.classList.add('highlights')
        setTimeout(() => {
          this.$refs.shadowsspan.classList.remove('highlights')
        }, 1000)
      }
    },
    highlights () {
      this.$refs.highlightsspan.classList.add('highlights')
      setTimeout(() => {
        this.$refs.highlightsspan.classList.remove('highlights')
      }, 1000)
    },
    highlightsStatus (val) {
      this.deleteAmp()
      if (val === true) {
        this.$refs.highlightsspan.classList.add('highlights')
        setTimeout(() => {
          this.$refs.highlightsspan.classList.remove('highlights')
        }, 1000)
      }
    },
    reset () {
      this.colorsGroup = ''
      this.grayscale = 'true'
      this.grayscaleStatus = false
      this.brightness = 0
      this.brightnessStatus = true
      this.contrast = 0
      this.contrastStatus = true
      this.exposure = 0
      this.exposureStatus = true
      this.hue = 0
      this.hueStatus = true
      this.saturation = 0
      this.saturationStatus = true
      this.lightness = 0
      this.lightnessStatus = true
      this.shadows = 0
      this.shadowsStatus = true
      this.highlights = 0
      this.highlightsStatus = true
    }
  }
}
</script>
<style lang="scss">
.el-button--primary{
  background-color: #327BBA;
  &:hover{
    background-color: #327BBA;
    opacity: .9;
  }
}
.control_app {
  padding: 70px 20px 10px;
  position: relative;
  @media only screen and (min-width : 767px){
    padding: 10px 20px;
  }
}
.control__title{
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
  display: flex;
  color: #2f363f;
  align-items: center;
}
.el-color-dropdown__btns .el-color-dropdown__link-btn{
  display: none;
}
.el-color-dropdown__btns .is-plain{
  background-color: #327BBA;
  color: #fff;
}
.el-collapse-item__header{
  font-weight: bold;
  font-size: 14px;
  color: #2f363f;
}
.collapsed{
  margin: 10px 0;
}
.option_select{
  margin-right: 10px;
  max-width: 140px;
}
.numberfield{
  width: 100%;
  max-width: 150px;
  input{
    width: 100%;
  }
  @media only screen and (min-width : 767px){
    margin-right: 10px;
  }
}
.slider {
  width: 100%;
  max-width: 320px;
  margin-right: 10px;
  input{
    width: 100%;
  }
}
.fakeoverlay {
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: block;
}
.disabled {
  position: absolute;
  cursor: not-allowed;
  z-index: 3;
}
.disabledStatus {
  position: absolute;
  cursor: not-allowed;
  z-index: 3;
  width: 100%;
  min-height: 6px;
}
.select_disabled {
  position: relative;
  z-index: 2;
  cursor: not-allowed;
}
.textfield {
  width: 100%;
  max-width: 320px;

  input{
    width: 100%;
  }
  @media only screen and (min-width : 767px){
    margin-right: 10px;
  }
}
.textcolor{
  width: 100%;
  max-width: 320px;
  margin-right: 10px;
  input{
    width: 100%;
  }
  .el-color-picker__mask,
  .el-color-picker__trigger{
    max-width: 320px;
    width: 100%;
  }
}
.font_choice{
  position: relative;
  width: 100%;
  max-width: 320px;
  input{
    width: 100%;
  }
  @media only screen and (min-width : 767px){
    margin-right: 10px;
  }
}
.fontfamily_choice{
  width: 100%;
  max-width: 150px;
  input{
    width: 100%;
  }
  &.right{
    margin-left: 10px;
  }
  @media only screen and (min-width : 767px){
    margin-right: 10px;
    &.right{
      margin-left: 10px;
    }
  }
}
.fakeoverlay {
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: block;
}
.slider_wrapper{
  position: relative;
  width: 100%;
  max-width: 320px;
  margin-right: 10px;
  min-height: 40px;
  input{
    width: 100%;
  }
}
.disabled {
  position: absolute;
  cursor: not-allowed;
  z-index: 3;
}
.disabledStatus {
  position: absolute;
  cursor: not-allowed;
  z-index: 3;
  width: 100%;
  min-height: 6px;
}
.select_disabled {
  position: relative;
  z-index: 2;
  cursor: not-allowed;
}
.units_choice{
  max-width: 150px;
  margin: 0 10px;
  position: relative;
  top: -1px;
  &.disabled .el-input__inner{
    color: #DCDFE6;
  }
}
.el-scrollbar__wrap{
  overflow: auto;
}
.el-select-dropdown__wrap{
  min-height: 90px;
}
.control__enable label {
  margin-bottom: 0;
}

.control__action{
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  align-items: center;
  .changeoption {
    cursor: pointer;
    margin: 0 10px 10px;
  }
}
@-moz-document url-prefix() {
  .control__title,
  .el-collapse-item__header {
    font-size: 14px;
    font-weight: normal;
  }
}
.control__item{
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  flex-direction: column;
  justify-content: center;
  padding-top: 2px;
}
.urlspan{
  padding: 2px 0;
  border-radius: 2px;
}
.highlights{
  color: #fff;
  background-color: #327BBA;
}
.showurl {
  word-break: break-all;
  background-color: #FFF;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  max-width: 520px;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  line-height: 1.5;
  outline: 0;
  padding: 15px;
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 100%;
  user-select: none;
}
.showurl span::before {
  content: '&';
}
.showurl span.withoutAmp::before {
  content: '';
}
.showurl span:first-child::before {
  content: '';
}
.showurl span:nth-child(2)::before {
  content: '';
}
.showurl input{
  cursor: pointer;
  position: relative;
  cursor: pointer !important;
  z-index: 5;
  font-weight: bold;
}
.control__btn{
  padding: 15px 0;
  display: flex;
  justify-content: space-between;
  position: relative;
  cursor: pointer;
  z-index: 5;
  .showurl{
    max-width: 100%;
    margin-bottom: 10px;
    cursor: pointer;
  }
}
.el-input.is-disabled .el-input__inner{
  background-color: transparent;
  cursor: default;
}
.copybutton {
  position: relative;
}
.copybutton, .external{
  width: 35px;
  height: 35px;
  display: inline-flex;
  cursor: pointer;
  padding: 0;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background-color: #327BBA;
  border-color: #327BBA;
  color: #fff;
  transition: background-color .5s ease, color .5s ease;
  margin-left: 15px;
  position: relative;
  transition: opacity .5s ease;
  &:hover{
    background-color: #327BBA;
    border-color: #327BBA;
    color: #fff;
    opacity: .8;
  }
}
.actions {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px 0;
  &-active {
    position: relative;
  }
}
.copymessage{
  font-size: 14px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: -45px;
  color: #327BBA;
}
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #327BBA;
  border-color: #327BBA;
}
.el-checkbox__inner:hover,
.el-select .el-input.is-focus .el-input__inner,
.el-select .el-input__inner:focus,
.el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: #327BBA;
}
.el-select-dropdown__item.selected{
  color: #327BBA;
}
@-moz-document url-prefix() {
  .copymessage{
    right: 0px;
  }
}
.control__action.units{
  display: flex;
  justify-content: center;
  align-items: flex-start;
  label {margin: 0 0 15px;}
}
.enable_checkbox {
  margin: 10px 0px;
  @media only screen and (min-width : 767px){
    margin: 10px;
  }
}
@media only screen and (min-width : 767px){
  .enable_checkbox{
    margin: 0;
  }
  .control__item{
    flex-direction: row;
    justify-content: left;
  }
  .control__title {
    min-width: 140px;
    max-width: 140px;
    margin-right: 10px;
    margin-bottom: 0;
  }
  .control__action{
    text-align: left;
    flex-direction: row;
    .changeoption{
      margin: 0 10px;
    }
  }
  .control__action.units{
    align-items: center;
    label {margin: 0 15px;}
  }
  .control__btn{
    .showurl{
      margin-bottom: 0;
      position: relative;
      z-index: 3;
    }
  }
}
.reset{
  width: 35px;
  height: 35px;
  border-radius: 4px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 35px;
  top: 15px;
  background-color: #327BBA;
  color: #fff;
  cursor: pointer;
  transition: opacity .5s ease;
  &:hover{
    opacity: .8;
  }
}
</style>
